import { ConfigProvider, MenuProps, Layout, Menu } from 'antd';
import { useState } from 'react';
import Icon from '../../Icon/Icon';
import { useNavigate } from 'react-router-dom';
import styles from './DashboardLayout.module.css';
import classNames from 'classnames';

type MenuItem = Required<MenuProps>['items'][number];

const { Sider } = Layout;

const Sidebar = () => {
  const navigate = useNavigate();

  const [current, setCurrent] = useState('1');

  const onClick: MenuProps['onClick'] = (e) => {
    setCurrent(e.key);
  };

  const sidebarItemStyles = {
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    fontFamily: 'JLRBody',
    fontWeight: 500,
    borderBottom: '1px solid white',
    borderRadius: '0px',
  };

  const sidebarTheme = {
    components: {
      Menu: {
        itemHoverBg: '#FFFFFF',
        itemHoverColor: '#000000',
        itemSelectedBg: '#ffffff',
        itemSelectedColor: '#000000',
        itemColor: '#ffffff',
      },
    },
  };

  const sidebarItems: MenuItem[] = [
    {
      key: '1',
      label: 'Vehicle History',
      icon: <Icon name="Directions_car" style={{ fontSize: '24px', marginLeft: '-7px' }} />,
      style: sidebarItemStyles,
      // onClick: () => navigate('/dashboard/vehiclehistory'),
      onClick: () => {
        window.location.href = '/dashboard/vehiclehistory';
      },
    },
    {
      key: '2',
      label: 'DTC Query',
      icon: <Icon name="search" style={{ fontSize: '24px', marginLeft: '-7px' }} />,
      style: sidebarItemStyles,
      onClick: () => navigate('/dashboard/dtcquery'),
    },
    {
      key: '3',
      label: 'DID Query',
      icon: <Icon name="search" style={{ fontSize: '24px', marginLeft: '-7px' }} />,
      style: sidebarItemStyles,
      onClick: () => navigate('/dashboard/didquery'),
    },
    {
      key: '4',
      label: 'Application Query',
      icon: <Icon name="search" style={{ fontSize: '24px', marginLeft: '-7px' }} />,
      style: sidebarItemStyles,
      onClick: () => navigate('/dashboard/applicationquery'),
    },
    {
      key: '5',
      label: 'Concern Query',
      icon: <Icon name="search" style={{ fontSize: '24px', marginLeft: '-7px' }} />,
      style: sidebarItemStyles,
      onClick: () => navigate('/dashboard/concernquery'),
    },
  ];

  return (
    <ConfigProvider theme={sidebarTheme}>
      <Sider
        className={classNames(styles['DashboardLayout--Sidebar'])}
        style={{ position: 'relative' }}
        width={240}
      >
        <Menu
          mode="vertical"
          theme="light"
          onClick={onClick}
          style={{
            height: 'calc(100vh-64px)',
            position: 'sticky',
            fontWeight: 400,
            fontSize: 15,
          }}
          className={classNames(styles['DashboardLayout--Sidebar'])}
          defaultSelectedKeys={[`3`]}
          selectedKeys={[current]}
          items={sidebarItems}
        />
      </Sider>
    </ConfigProvider>
  );
};

export default Sidebar;
